import createIcon from '../../createIcon';

/**
 * @component @name ContactMail
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjEgOFY3TDE4IDlMMTUgN1Y4TDE4IDEwTDIxIDhaTTIyIDNIMkMwLjkgMyAwIDMuOSAwIDVWMTlDMCAyMC4xIDAuOSAyMSAyIDIxSDIyQzIzLjEgMjEgMjMuOTkgMjAuMSAyMy45OSAxOUwyNCA1QzI0IDMuOSAyMy4xIDMgMjIgM1pNOCA2QzkuNjYgNiAxMSA3LjM0IDExIDlDMTEgMTAuNjYgOS42NiAxMiA4IDEyQzYuMzQgMTIgNSAxMC42NiA1IDlDNSA3LjM0IDYuMzQgNiA4IDZaTTE0IDE4SDJWMTdDMiAxNSA2IDEzLjkgOCAxMy45QzEwIDEzLjkgMTQgMTUgMTQgMTdWMThaTTIyIDEySDE0VjZIMjJWMTJaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const ContactMail = createIcon('ContactMail', [
  [
    'path',
    {
      d: 'M21 8V7L18 9L15 7V8L18 10L21 8ZM22 3H2C0.9 3 0 3.9 0 5V19C0 20.1 0.9 21 2 21H22C23.1 21 23.99 20.1 23.99 19L24 5C24 3.9 23.1 3 22 3ZM8 6C9.66 6 11 7.34 11 9C11 10.66 9.66 12 8 12C6.34 12 5 10.66 5 9C5 7.34 6.34 6 8 6ZM14 18H2V17C2 15 6 13.9 8 13.9C10 13.9 14 15 14 17V18ZM22 12H14V6H22V12Z',
      key: '12zk7u',
    },
  ],
]);

export default ContactMail;
